import { render, staticRenderFns } from "./CreateClient.vue?vue&type=template&id=0b3a1f2c&scoped=true"
import script from "./CreateClient.vue?vue&type=script&lang=js"
export * from "./CreateClient.vue?vue&type=script&lang=js"
import style0 from "./CreateClient.vue?vue&type=style&index=0&id=0b3a1f2c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3a1f2c",
  null
  
)

export default component.exports